import React from 'react';
import DetailsModelTableRow from '../details-model-table-row';
import rowColors from './utils/details-model-colors';
import DetailsModelTableWrapper from '../details-model-table-wrapper';
import CalcBreakdownRows from './details-model-calc-breakdown';

const { rowColor1, rowColor2, rowColor3 } = rowColors;

const MarkupDetailsModalTable = ({ type, calcBreakDown, tableData, hideDetails }) => {
  const { markupDetails } = tableData;

  console.log(hideDetails);

  // Markup
  const { breakdownValues, markupPercentage, markupCost, totalAfterMarkup, totalMarkupPercentage } =
    markupDetails;

  return (
    <DetailsModelTableWrapper
      type={type}
      subtotal={totalAfterMarkup[5].toFixed(2)}
      TotalCost={markupCost[5].toFixed(2)}
      tableData={tableData}
      hideDetails={hideDetails}
    >
      {[
        {
          title: 'Markup Cost',
          values: markupCost.map((item) => `$${item.toFixed(2)}`),
        },
        {
          title: 'Markup Percentage',
          values: markupPercentage.map((item) => `${item.toFixed(2)}%`),
        },
        {
          title: 'Total Cost With Markup',
          values: totalAfterMarkup.map((item) => `$${item.toFixed(2)}`),
          boldValues: true,
        },
        {
          title: 'Total Percentage With Markup',
          values: totalMarkupPercentage.map((item) => `${item.toFixed(2)}%`),
          bgColor: rowColor1,
        },
      ].map((row, index) => (
        <DetailsModelTableRow
          key={index}
          title={row.title}
          description={row?.description || ''}
          values={row.values}
          bgColor={row?.bgColor || ''}
          boldValues={row?.boldValues || false}
          hideDetails={hideDetails}
        />
      ))}

      {calcBreakDown && (
        <CalcBreakdownRows
          breakdownValues={breakdownValues}
          title={`Total ${type} Cost`}
          costs={markupCost}
          hideDetails={hideDetails}
        />
      )}
    </DetailsModelTableWrapper>
  );
};

export default MarkupDetailsModalTable;
